import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import WhopSubscriptionsPanel from '@/components/WhopSubscriptionsPanel';
import SystemSubscriptionsPanel from '@/components/SystemSubscriptionsPanel';
import HiringTransactionsPanel from '@/components/HiringTransactionsPanel';
import CreditHiresPanel from '@/components/CreditHiresPanel';

// Each TabsContent below only mounts its panel while active — Radix's Tabs
// primitive doesn't render inactive content unless forceMount is passed, so
// the useQuery inside each panel doesn't exist (and can't fetch) until its
// tab is selected. Switching tabs fetches the newly active one; it never
// fetches both at once. More tabs slot in the same way: one TabsTrigger + one
// TabsContent wrapping a panel component.
export default function AccountsFinance() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold tracking-tight">Accounts & Finance</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Brand dashboard subscription and hiring payments, from four different sources of truth.
        </p>
      </div>

      <Tabs defaultValue="whop" className="w-full">
        <TabsList>
          <TabsTrigger value="whop">Whop Subscriptions</TabsTrigger>
          <TabsTrigger value="system">System Subscriptions</TabsTrigger>
          <TabsTrigger value="hiring">Hiring Transactions</TabsTrigger>
          <TabsTrigger value="credit-hiring">Credit Hires</TabsTrigger>
        </TabsList>
        <TabsContent value="whop">
          <WhopSubscriptionsPanel />
        </TabsContent>
        <TabsContent value="system">
          <SystemSubscriptionsPanel />
        </TabsContent>
        <TabsContent value="hiring">
          <HiringTransactionsPanel />
        </TabsContent>
        <TabsContent value="credit-hiring">
          <CreditHiresPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}
